import React from "react";

import "./GetAppModal.scss";
import CloseIcon from "../icons/CloseIcon";
import GetAppContent from "./GetAppContent";

import { useWindowDimensions } from "../../hooks/useWindowDimensions";
import BottomDrawer from "../BottomDrawer/BottomDrawer";

interface GetAppModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function GetAppModal({ isOpen, onClose }: GetAppModalProps) {
  const { width: windowWidth } = useWindowDimensions();
  const isDesktop = windowWidth >= 1024;

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isDesktop) {
    return (
      <BottomDrawer
        isOpen={isOpen}
        onClose={onClose}
        containerClass="GetAppDrawer"
        bodyClass="d-flex justify-content-center align-items-center p-4"
        showCloseBtn={true}
      >
        <GetAppContent />
      </BottomDrawer>
    );
  }

  return (
    <div className="GetAppModal" onClick={handleBackdropClick}>
      <div className="ModalContent">
        <button
          className="CloseButton"
          onClick={onClose}
          aria-label="Close modal"
        >
          <CloseIcon />
        </button>

        <GetAppContent className="ContentArea" />
      </div>
    </div>
  );
}
